/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * App object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var App = {
    version: $("html").data("version"),
    account_id: $("html").data("account"),

    isLogged: function () {
        return this.account_id != 0;
    },

    get: function (index) {
        return window.location.pathname.split("/")[index];
    },

    hash: function () {
        return window.location.hash.substring(1);
    },

    getSessionToken: function () {
        var name = "session=";

        var map = {
            "habtium.es": "session=",
            "www.habtium.es": "session=",
            localhost: "session_dev=",
            "127.0.0.1": "session_dev=",
            "::1": "session_dev=",
            "canary.habtium.es": "session_canary=",
        };

        name = map[window.location.hostname] || "session=";

        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    },

    echo: function (first, second) {
        document.write(first);
    },

    formatNumber: function (number, digits) {
        return ("0" + number).slice(0 - digits);
    },

    startInterval: function (cb, time) {
        cb();
        return setInterval(cb, time);
    },
};
